import { render, staticRenderFns } from "./LupaPassword.vue?vue&type=template&id=f0041624&"
import script from "./LupaPassword.vue?vue&type=script&lang=js&"
export * from "./LupaPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LupaPassword.vue"
export default component.exports